import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { glassStyles } from '../utils/glassStyles';
import { useLanguage, t } from '../utils/i18n';

const ProductCard = ({ product, onAddToCart }) => {
  const { language } = useLanguage();

  const productLink = `/product/${product.slug || product.id}`;

  return (
    <div 
      className="rounded-[2rem] overflow-hidden h-full flex flex-col" 
      style={{ 
        ...glassStyles.static,
        border: '1px solid rgba(255, 255, 255, 0.2)'
      }}
    >
      <Link to={productLink} className="block flex-shrink-0">
        <div className="relative pb-[100%]">
          {product.image ? (
            <img 
              src={product.image}
              alt={product.name}
              className="absolute inset-0 w-full h-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 w-full h-full bg-white/10 flex items-center justify-center">
              <span className="text-white/70">{t('product.noImage', language.code)}</span>
            </div>
          )}
        </div>
      </Link>
      <div className="p-4 text-white flex flex-col flex-grow">
        <h3 className="text-lg font-medium text-white truncate mb-1">{product.name}</h3>
        {product.material && <p className="text-sm text-white/80 mt-1 truncate">{product.material}</p>}
        
        <div className="mt-auto pt-4 flex justify-between items-center">
          {typeof product.price === 'number' && 
            <span className="text-white font-bold">${product.price.toLocaleString()}</span>
          }
          <Link 
            to={productLink} 
            className="px-4 py-2 rounded-full text-sm font-medium text-white focus:outline-none"
            style={glassStyles.button}
          >
            {t('product.viewDetails', language.code)} 
          </Link>
          {onAddToCart && (
            product.stock > 0 ? (
             <motion.button 
               onClick={() => onAddToCart(product)}
               className="px-3 py-1 rounded-full text-sm font-medium text-white focus:outline-none ml-2"
               style={glassStyles.button}
               whileHover={glassStyles.buttonHover}
               whileTap={{ scale: 0.95 }}
             >
               {t('product.addToCart.short', language.code)} 
             </motion.button>
            ) : (
             <motion.a
               href={`https://wa.me/5511605388?text=${encodeURIComponent(
                 `Hola, me interesa el producto "${product.name}". ¿Podrían proporcionarme más información sobre disponibilidad?`
               )}`}
               target="_blank"
               rel="noopener noreferrer"
               className="px-3 py-1 rounded-full text-sm font-medium text-white focus:outline-none ml-2 bg-green-600/20 border border-green-400/30 hover:bg-green-600/30 transition-colors duration-300"
               whileHover={{ scale: 1.05 }}
               whileTap={{ scale: 0.95 }}
             >
               {t('product.onRequest.title', language.code)}
             </motion.a>
            )
          )}
        </div>
        {/* Stock status indicator */}
        {product.stock !== undefined && product.stock === 0 && (
          <div className="mt-2 text-center">
            <span className="text-xs text-yellow-300 bg-yellow-600/20 px-2 py-1 rounded-full">
              {t('product.onRequest.title', language.code)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
